import { render, staticRenderFns } from "./ExtendedSearch.vue?vue&type=template&id=3e8247b3&scoped=true"
import script from "./ExtendedSearch.vue?vue&type=script&lang=js"
export * from "./ExtendedSearch.vue?vue&type=script&lang=js"
import style0 from "./ExtendedSearch.vue?vue&type=style&index=0&id=3e8247b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8247b3",
  null
  
)

export default component.exports